// extracted by mini-css-extract-plugin
module.exports = {"landing-image":"LandingImage_landing-image__2edMH","button-outline":"LandingImage_button-outline__1vY4Z","button-primary":"LandingImage_button-primary__13Aym"};